import * as React from 'react';
import { SVGProps } from 'react';

const CitiLogo = (props: SVGProps<any>): JSX.Element => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={props.width || 90}
      height={props.height || 52}
      fill='none'
      viewBox='0 0 90 52'
      className={props.className}
      {...props}
  >
    <g clipPath='url(#a)'>
      <path
        fill='#255BE3'
        d='M.418 35.239c0-9.251 7.564-16.454 17.423-16.454 5.704 0 10.912 2.546 13.889 6.395l-4.279 4.285a12.262 12.262 0 0 0-9.548-4.72c-5.89 0-10.603 4.41-10.603 10.494 0 6.147 4.713 10.555 10.603 10.555a12.382 12.382 0 0 0 9.858-4.905l4.217 4.16c-2.853 4.036-8.309 6.706-14.137 6.706-9.859 0-17.423-7.203-17.423-16.516ZM37.559 19.904h6.757V50.64h-6.757V19.904ZM56.902 42.38V25.614h-7.379v-5.712h7.69V13.32l6.323-3.104v9.686h10.045v5.712H63.536v15.647c0 3.105 1.736 4.47 5.022 4.47 1.71.009 3.402-.351 4.96-1.055v5.836a14.725 14.725 0 0 1-6.2 1.242c-6.014 0-10.416-3.29-10.416-9.376ZM78.914 19.904h6.757V50.64h-6.757V19.904Z'
      />
      <path
        fill='#FF3C28'
        d='M61.554.346a34.554 34.554 0 0 1 15.955 3.861A34.606 34.606 0 0 1 89.889 15h-7.874a27.53 27.53 0 0 0-9.261-6.742 27.491 27.491 0 0 0-31.66 6.742h-7.875a34.606 34.606 0 0 1 12.38-10.792A34.552 34.552 0 0 1 61.555.346Z'
      />
    </g>
    <defs>
      <clipPath id='a'>
        <path fill='#fff' d='M0 0h89.917v52H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default CitiLogo;
